import { render } from "./AllTasksToday.vue?vue&type=template&id=66fc8709"
import script from "./AllTasksToday.vue?vue&type=script&lang=js"
export * from "./AllTasksToday.vue?vue&type=script&lang=js"

import "./AllTasksToday.vue?vue&type=style&index=0&id=66fc8709&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__